module.exports = __webpack_public_path__ + "static/media/poster.1a572651.png";